import { render, staticRenderFns } from "./lackPackagesSummary.vue?vue&type=template&id=6ff0020b&scoped=true&"
import script from "./lackPackagesSummary.vue?vue&type=script&lang=js&"
export * from "./lackPackagesSummary.vue?vue&type=script&lang=js&"
import style0 from "./lackPackagesSummary.vue?vue&type=style&index=0&id=6ff0020b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0020b",
  null
  
)

export default component.exports